<script setup lang="ts">
import { storeToRefs } from "pinia";
import { LightDarkImage } from '@/components';
import { useSpinnerStore } from "@/stores";
import catapultLogoWhite from '@/assets/logos/logo-catapult-white.svg'
import catapultLogo from '@/assets/logos/logo-catapult.svg'

const { text, visible } = storeToRefs(useSpinnerStore());
</script>

<template>
    <div v-show="visible" fluid class="_overlay" id="loadingSpinner">
        <ILoader color="primary" size="lg" />
        <div class="loading-content">
          <LightDarkImage aria-hidden="true" alt="Catapult logo"
            :dark-src="catapultLogoWhite"
            :src="catapultLogo"
            class="loading-logo" />
          <div class="loading-text">{{ text }}</div>
        </div>
    </div>
</template>
